import { ArrowUpRight, CheckCircle2, Star } from 'lucide-react';
import { Link } from 'react-router-dom';
import { formatCurrency } from '../lib/formatters';

export function ListingCard({ listing }) {
  const pricingSuffix = listing.pricingType === 'subscription' ? ` / ${listing.billingInterval || 'month'}` : '';

  return (
    <article className="listing-card simple-listing-card">
      <Link
        to={`/agents/${listing.slug}`}
        className={`listing-card-cover simple-cover${listing.thumbnailUrl ? ' has-image' : ''} tone-${
          listing.tone || 'graphite'
        }`}
      >
        {listing.thumbnailUrl ? (
          <img className="listing-card-cover-image" src={listing.thumbnailUrl} alt="" loading="lazy" />
        ) : null}
        <div className="listing-card-cover-inner">
          <span className="listing-badge">{listing.category?.name || 'Agent'}</span>
        </div>
      </Link>

      <div className="listing-card-content">
        <Link to={`/agents/${listing.slug}`} className="listing-card-title">
          <h3>{listing.title}</h3>
          <p>{listing.tagline}</p>
        </Link>

        <div className="listing-card-bottom-row">
          <div className="listing-card-seller-inline">
            <div className="seller-avatar">{listing.seller?.name?.slice(0, 1) || 'A'}</div>
            <span className="listing-card-seller-name">{listing.seller?.name || 'Marketplace seller'}</span>
          </div>

          <div className="listing-card-meta">
            <span className="listing-card-rating">
              <Star size={13} />
              {listing.rating.toFixed(1)}
            </span>
            {listing.verified ? (
              <span className="listing-card-verified">
                <CheckCircle2 size={13} />
                Verified
              </span>
            ) : null}
          </div>
        </div>
      </div>

      <div className="listing-card-footer">
        <div>
          <span className="metric-label">From</span>
          <strong>{`${formatCurrency(listing.priceFrom)}${pricingSuffix}`}</strong>
        </div>
        <Link to={`/agents/${listing.slug}`} className="inline-link">
          Details
          <ArrowUpRight size={14} />
        </Link>
      </div>
    </article>
  );
}
